import React, { PropsWithChildren, ReactNode } from 'react';
import { Link } from 'react-router-dom';
import Typography from 'new/elements/TypographySupport';
import { Button } from 'new/elements/Button';
import { ReactComponent as PlusIcon } from 'new/components/icons/fi-rr-plus.svg';

import classes from './BannerDescription.module.scss';

interface BannerDescriptionProps {
  actionTitle?: string;
  description?: string | ReactNode;
  onClick?: () => void;
  title: string;
  to?: string;
  children?: ReactNode;
  rightView?: ReactNode;
}

export const BannerDescription = (props: PropsWithChildren<BannerDescriptionProps>) => {
  const { title, description, to, actionTitle, children, onClick, rightView } = props;

  let desc = null;
  if (description) {
    if (typeof description === 'string') {
      desc = (
        <Typography className={classes.description} variant="body2">
          {description}
        </Typography>
      );
    } else if (React.isValidElement(description)) {
      desc = React.cloneElement(description, {
        ...description.props,
        variant: 'body2',
        className: classes.description,
      });
    }
  }

  const renderActionButton = () => {
    if (!to && !onClick) return null;

    const label = actionTitle || 'Create';
    const buttonContent = to ? <Link to={to}>{label}</Link> : label;

    return (
      <Button
        variant="contained"
        color="primary"
        className={classes.actionButton}
        onClick={!to ? onClick : undefined}
        data-testid="banner-description-action-button"
        startIcon={<PlusIcon />}
      >
        {buttonContent}
      </Button>
    );
  };

  return (
    <div className={classes.rootContainer}>
      <div className={classes.container}>
        <div className={classes.info}>
          <Typography className={classes.title} variant="h3">
            {title}
          </Typography>
          {desc}
        </div>

        {rightView}

        {renderActionButton()}
      </div>

      {children}
    </div>
  );
};
